import React from 'react';
import { Divider } from 'components/Divider';

export const NavBarDivider: React.FC = () => {
  return (
    <Divider sx={{ height: '30px' }} />
  );
};
